import React from 'react';

import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

import { getActualHikingList } from '@apps/Hiking/@services/hiking.service';
import { IBaseHikingWithType } from '@apps/Hiking/@types/hikingList.types';
import CountDownTimer from '@components/CountdownTimer';
import PageLoader from '@components/PageLoader';
import { dateRangeToLocaleString } from '@helpers/dateHelper';
import PohAlert, { AlertVariant } from '@ui-kit/Alert';
import PohAva from '@ui-kit/Ava';
import PohBadge, { BadgeVariant } from '@ui-kit/Badge/Badge';
import PohList from '@ui-kit/List';

const ActualHikingWidget = () => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState<Error>();
  const [data, setData] = React.useState<IBaseHikingWithType[]>([]);

  const navigate = useNavigate();

  const load = React.useCallback(async () => {
    try {
      setIsLoading(true);
      const r = await getActualHikingList();
      setData(r);
    } catch (e) {
      setError(e as Error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  React.useEffect(() => {
    load();
  }, [load]);

  if (isLoading) return <PageLoader />;
  if (error) return <PohAlert variant={AlertVariant.Danger}>{error.message}</PohAlert>;

  return (
    <section>
      <h2 className="text-muted">Ближайшие активности</h2>
      {!data.length && (
        <div className="text-muted">
          На ближайшее время активностей не запланировано 😴
          <br />
          Это можно исправить если самостоятельно создать <NavLink to="/hiking/new">
            поход
          </NavLink>{' '}
          или <NavLink to="/routes/add">маршрут</NavLink>
          <hr />
          Если настроить <NavLink to="/profile#subscribes">подписки</NavLink> - мы пригласим вас в
          поход, когда он появится на сайте
        </div>
      )}
      <PohList
        data={data.map((item) => {
          return {
            key: item.id,
            children: (
              <div className="d-flex">
                <PohAva alt={item.name} src={item.ava} colorize width={56} className="me-2" />
                <div>
                  <strong className="d-block">
                    {item.name}{' '}
                    <small>
                      <PohBadge variant={BadgeVariant.Success}>{item.type.name}</PohBadge>
                    </small>
                  </strong>
                  <small className="d-block">
                    {dateRangeToLocaleString(item.start, item.finish)}
                  </small>
                  <small className="text-info">
                    Через: <CountDownTimer targetDate={item.start} withSeconds />
                  </small>
                </div>
              </div>
            ),
            action: true,
            onClick: () => navigate(`/hiking/${item.id}`),
          };
        })}
      />
    </section>
  );
};
export default ActualHikingWidget;
